export default __webpack_public_path__ + "static/add@768-cbeb16eb9b0d3eed0bb021785abaad03.svg";